import { render, staticRenderFns } from "./plan-details-zoneduschcmp.vue?vue&type=template&id=6bdfd345"
import script from "./plan-details-zoneduschcmp.vue?vue&type=script&lang=js"
export * from "./plan-details-zoneduschcmp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports